export enum ModalSize {
  ExtraSmall = 'max-h-[32vh] min-h-[32vh] sm:min-w-[30rem] sm:max-w-[30rem]',
  Small = 'max-h-[50vh] min-h-[50vh] sm:max-h-[46vh] sm:min-h-[46vh] sm:min-w-[30rem] sm:max-w-[30rem]',
  Medium = 'max-h-[66vh] min-h-[66vh] sm:max-h-[62vh] sm:min-h-[62vh] sm:min-w-[34rem] sm:max-w-[34rem]',
  Large = 'max-h-[76vh] min-h-[76vh] sm:max-h-[72vh] sm:min-h-[72vh] sm:min-w-[40rem] sm:max-w-[40rem]',
  Full = 'max-h-screen w-screen min-w-[100vw] min-h-[100vh]',
}

export type ModalOptions = keyof typeof ModalSize;
